module.exports = __webpack_public_path__ + "static/k-store-4-87af2548314efafc775bd4a6264c9522.jpg";